import React from 'react';
import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { getApiHeader } from 'utlis/commonfunctions';
import { ToastContainer, toast } from "react-toastify";
import swal from 'sweetalert';
import DataTable from "react-data-table-component";
import SortIcon from "@material-ui/icons/ArrowDownward";




import Switch from "@mui/material/Switch";
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import SoftInput from "components/SoftInput";
import SoftButton from "components/SoftButton";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "layouts/authentication/components/Footer";
import BillingInformation from "layouts/billing/components/BillingInformation";
import Transactions from "layouts/billing/components/Transactions";
import { colors } from '@mui/material';
import { Color } from 'chroma-js';


const SERVER_URL = process.env.REACT_APP_API_URL;

function SearchStore() {

  const [activeTab, setActiveTab] = useState("pageOne")
  const [currentPage, setCurrentPage] = useState(1);
  const [retailerData, setRetailerData] = useState([])
  const [rememberMe, setRememberMe] = useState(false);
  const [rememberMe1, setRememberMe1] = useState(false);
  const handleSetRememberMe1 = () => setRememberMe1(!rememberMe1);
  const [allocateBox, setAllocateBox] = useState(false);
  const [retailerBox, setRetailerBox] = useState(false)
  const [tableView, setTableView] = useState(false);

  const [selectedRows, setSelectedRows] = useState(false);
  const [toggledClearRows, setToggleClearRows] = useState(false);




  const rowsPerPage = 10;
  const indexOfLastRow = currentPage * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;
  const currentData = retailerData.slice(indexOfFirstRow, indexOfLastRow);



  const [formData, setFormData] = useState({
    retailer_code: "",
    store_name: "",
    email: "",
    abn: "",
    state: "",
    city: "",
    postcode: "",
    street_name: "",
  });


  const handleSubmit = async (e) => {
    e.preventDefault();
    if (
      formData.retailer_code === "" &&
      formData.store_name === "" &&
      formData.email === "" &&
      formData.abn === "" &&
      formData.state === "" &&
      formData.city === "" &&
      formData.postcode === "" &&
      formData.street_name === ""
    ) {
      toast.error("At least one input field must be filled");
      setTableView(false);
      return;
    } else if (formData.street_name && (formData.city === "" && formData.postcode === "")) {
      toast.error("Please enter  post code or city name");
      setTableView(false);
      return;
    } else if (formData.state && (formData.city === ""&& formData.postcode === "")) {
      toast.error("Please enter street name or post code");
      setTableView(false);
      return;
    }
    
    const headers = await getApiHeader();

    const filteredFormData = Object.fromEntries(
      Object.entries(formData).filter(([key, value]) => value !== "")
    );
    try {
      const response = await axios.post(`${SERVER_URL}search-retailer-store`, filteredFormData, {
        headers: headers
      });
      if (response.status === 200) {
        setRetailerData(response.data.data)
        console.log("store-response", response)
        if (response.data.data !== null && response.data.data.length > 0) {
          setTableView(true);
          toast.success(response.data.message);
        } else {
          setTableView(false);
          toast.error("No data found during searching");
        }
        console.log("response", response.data.data);
      }
    } catch (error) {
      console.log(error)
      const errorMessage = error?.response?.data?.message || "An error occurred";
      if (typeof errorMessage === 'object') {
        Object.keys(errorMessage).forEach(key => {
          errorMessage[key].forEach(message => {
            toast.error(message);
          });
        });

      } else {
        toast.error(errorMessage);

      }
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
      setFormData({
        ...formData,
        [name]: value
      });
  };




  const handlePrevious = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const handleNext = () => {
    if (currentPage < Math.ceil(retailerData.length / rowsPerPage)) {
      setCurrentPage(currentPage + 1);
    }
  };

  const handleAllocateBox = () => {
    setAllocateBox(true)
  }

  const handleSetRememberMe = () => {
    setRememberMe(!rememberMe);
    setRetailerBox(true)

  }

  const handleClose = () => {
    setAllocateBox(false)
  }

  const handleClear = () => {
    setFormData({
      retailer_code: "",
      store_name: "",
      email: "",
      abn: "",
      state: "",
      city: "",
      postcode: "",
      street_name: "",
    });
    setTableView(false)
  };



  const columns = [

    {
      id: 1,
      name: "Store Name",
      selector: (row) => row.retailer_company_name,
     
    },
    {
      id: 2,
      name: "Store Address",
      selector: (row) => row.retailer_store_address,
     
    },
    {
      id: 3,
      name: "Email Address",
      selector: (row) => row.retailer_email,
     
    },
    {
      id: 4,
      name: "Retailer ID",
      selector: (row) => row.retailer_code,
     
    },
    {
      id: 5,
      name: "ABN",
      selector: (row) => row.retailer_abn,
     
    },
      
  ];

  const paginationComponentOptions = {
    selectAllRowsItem: true,
    selectAllRowsItemText: "ALL"
  };


  const handleChanges = ({ selectedRows }) => {
    console.log("entered")
    console.log(selectedRows)
    setSelectedRows(selectedRows);
  };

 
  const handleClearRows = () => {
    setToggleClearRows(!toggledClearRows);
  }

  const rowDisabledCriteria = row => row.isOutOfStock;

  // const customStyles = {
  //   gyksGC: {
  //     style: {
  //       whiteSpace: "normal",
  //       overflow: "hidden",
  //       textOverflow: "ellipsis"
  //     }
  //   },
  //   fKWVwL: {
  //     style: {
  //       whiteSpace: "normal",
  //       overflow: "hidden",
  //       textOverflow: "ellipsis"
  //     }

  //   },
  //   rows: {
  //     style: {
  //       border: '1px solid #ccc!important'
  //     },
  //   },
  //   headCells: {
  //     style: {
  //       backgroundColor: '#f0f0f0',
  //       border: '1px solid #fff'
  //     },
  //   },
  //   cells: {
  //     style: {
  //       borderBottom: '2px solid #f0f0f0'
  //     },
  //   },
  // };



  const customStyles = {
    gyksGC: {
      style: {
        whiteSpace: "normal",
        overflow: "hidden",
        textOverflow: "ellipsis"
      }
    },
    fKWVwL: {
      style: {
        whiteSpace: "normal",
        overflow: "hidden",
        textOverflow: "ellipsis"
      }

    },
    rows: {
      style: {
        border: '1px solid #ccc', // Add border to rows
      },
    },
    headCells: {
      style: {
        backgroundColor: '#f0f0f0',
        border: '1px solid #ccc', // Add border to header cells
      },
    },
    cells: {
      style: {
        border: '1px solid #ccc', // Add border to individual cells
      },
    },
  };




















  return (
    <DashboardLayout>
      <DashboardNavbar />
      <>

        <div>
          <div className="formbold-main-wrapper">
            <div className="formbold-form-wrapper">
              <h3 style={{ textAlign: "center" }}>Search Store</h3>
              <form action="" method="" onSubmit={handleSubmit}>
                <div className="formbold-mb-5 formbold-pt-3">
                  <label className="formbold-form-label formbold-form-label-2">
                  </label>
                  <div className="flex flex-wrap formbold--mx-3">
                    <div className="w-full sm:w-half formbold-px-3">
                      <label htmlFor="store_name" className="formbold-form-label">
                        Store Name
                      </label>
                      <div className="formbold-mb-5">
                        <input
                          type="text"
                          name="store_name"
                          id="store_name"
                          placeholder="Enter Store Name"
                          className="formbold-form-input"
                          value={formData.store_name}
                          onChange={handleChange}
                          autoComplete="off"
                        />
                      </div>
                    </div>

                    <div className="w-full sm:w-half formbold-px-3">
                      <div className="formbold-mb-5">
                        <label htmlFor="store_name" className="formbold-form-label">
                          Email  Address
                        </label>
                        <input
                          type="email"
                          name="email"
                          id="email"
                          placeholder="Enter Email Address"
                          className="formbold-form-input"
                          value={formData.email}
                          onChange={handleChange}
                          autoComplete="off"
                        />
                      </div>
                    </div>

                    <div className="w-full sm:w-half formbold-px-3">
                      <div className="formbold-mb-5">
                        <label htmlFor="store_name" className="formbold-form-label">
                          Retailer ID
                        </label>
                        <input
                          type="text"
                          name="retailer_code"
                          id="retailer_code"
                          placeholder="Enter Retailer ID"
                          className="formbold-form-input"
                          value={formData.retailer_code}
                          onChange={handleChange}
                          autoComplete="off"
                        />
                      </div>
                    </div>
                    <div className="w-full sm:w-half formbold-px-3">
                      <div className="formbold-mb-5">
                        <label htmlFor="store_name" className="formbold-form-label">
                          ABN
                        </label>
                        <input
                          type="text"
                          name="abn"
                          id="abn"
                          placeholder="Enter ABN"
                          className="formbold-form-input"
                          value={formData.abn}
                          onChange={handleChange}
                          maxLength={12}
                          autoComplete="off"
                        />
                      </div>
                    </div>

                    <div className="w-full sm:w-half formbold-px-3">
                      <div className="formbold-mb-5">
                        <label htmlFor="store_name" className="formbold-form-label">
                          City 
                        </label>
                        <input
                          type="text"
                          name="city"
                          id="city"
                          placeholder="Enter City Name"
                          className="formbold-form-input"
                          value={formData.city}
                          onChange={handleChange}
                          autoComplete="new-password"
                        />
                      </div>
                    </div>
                    <div className="w-full sm:w-half formbold-px-3">
                      <div className="formbold-mb-5">
                        <label htmlFor="store_name" className="formbold-form-label">
                          Post Code 
                        </label>
                        <input
                          type="text"
                          name="postcode"
                          id="postcode"
                          placeholder="Enter Post Code"
                          className="formbold-form-input"
                          value={formData.postcode}
                          onChange={handleChange}
                          autoComplete="new-password"
                        />
                      </div>
                    </div>
                    <div className="w-full sm:w-half formbold-px-3">
                      <div className="formbold-mb-5">
                        <label htmlFor="store_name" className="formbold-form-label">
                          Street Name
                        </label>
                        <input
                          type="text"
                          name="street_name"
                          id="street_name"
                          placeholder="Enter Street Name"
                          className="formbold-form-input"
                          value={formData.street_name}
                          onChange={handleChange}
                          autoComplete="new-password"
                        />
                      </div>
                    </div>

                    <div className="w-full sm:w-half formbold-px-3">
                      <label htmlFor="store_name" className="formbold-form-label">
                        State
                      </label>
                      <select
                        className="formbold-form-input"
                        name="state"
                        id="state"
                        value={formData.state}
                        onChange={handleChange}
                      >
                        <option value="">Select State</option>
                        <option value="Act">ACT</option>
                        <option value="NSW">NSW</option>
                        <option value="NIT">NIT</option>
                        <option value="QLD">QLD</option>
                        <option value="SA">SA</option>
                        <option value="TAS">TAS</option>
                        <option value="VIC">VIC</option>
                        <option value="WA">WA</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div className="search-store-buttons">
                  <button className="search-store-button" type="submit"><i class="fa fa-search"></i> Search</button>
                  {
                    tableView && (
                      <button className="search-store-button" onClick={handleClear}>Clear</button>
                    )
                  }
                </div>

              </form>

              {tableView && (
                <div className="data-dummy-table">
                  <DataTable
                    title="Store Details"
                    columns={columns}
                    data={retailerData}
                    defaultSortFieldId={1}
                    sortIcon={<SortIcon />}
                    pagination
                    paginationComponentOptions={paginationComponentOptions}
                    // selectableRows
                    onSelectedRowsChange={handleChanges}
                    clearSelectedRows={toggledClearRows}
                    selectableRowDisabled={rowDisabledCriteria}
                    customStyles={customStyles}
                  />
                </div>
              )}
            </div>
          </div>
        </div>



        {/* <style
          dangerouslySetInnerHTML={{
            __html:
              "\n  @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap');\n  * {\n    margin: 0;\n    padding: 0;\n    box-sizing: border-box;\n  }\n  body {\n    font-family: \"Inter\", Arial, Helvetica, sans-serif;\n  }\n  .formbold-mb-5 {\n    margin-bottom: 20px;\n  }\n  .formbold-pt-3 {\n    padding-top: 12px;\n  }\n  .formbold-main-wrapper {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 48px;\n  }\n\n  .formbold-form-wrapper {\n    margin: 0 auto;\n    max-width: 550px;\n    width: 100%;\n    background: white;\n  }\n  .formbold-form-label {\n    display: block;\n    font-weight: 500;\n    font-size: 16px;\n    color: #07074d;\n    margin-bottom: 12px;\n  }\n  .formbold-form-label-2 {\n    font-weight: 600;\n    font-size: 20px;\n    margin-bottom: 20px;\n  }\n\n  .formbold-form-input {\n    width: 100%;\n    padding: 12px 24px;\n    border-radius: 6px;\n    border: 1px solid #e0e0e0;\n    background: white;\n    font-weight: 500;\n    font-size: 16px;\n    color: #6b7280;\n    outline: none;\n    resize: none;\n  }\n  .formbold-form-input:focus {\n    border-color: #6a64f1;\n    box-shadow: 0px 3px 8px rgba(0, 0, 0, 0.05);\n  }\n\n  .formbold-btn {\n    text-align: center;\n    font-size: 16px;\n    border-radius: 6px;\n    padding: 14px 32px;\n    border: none;\n    font-weight: 600;\n    background-color: #6a64f1;\n    color: white;\n    width: 100%;\n    cursor: pointer;\n  }\n  .formbold-btn:hover {\n    box-shadow: 0px 3px 8px rgba(0, 0, 0, 0.05);\n  }\n\n  .formbold--mx-3 {\n    margin-left: -12px;\n    margin-right: -12px;\n  }\n  .formbold-px-3 {\n    padding-left: 12px;\n    padding-right: 12px;\n  }\n  .flex {\n    display: flex;\n  }\n  .flex-wrap {\n    flex-wrap: wrap;\n  }\n  .w-full {\n    width: 100%;\n  }\n  @media (min-width: 540px) {\n    .sm\\:w-half {\n      width: 50%;\n    }\n  }\n"
          }}
        /> */}
        <>
        </>
      </>
    </DashboardLayout>

  )
}
export default SearchStore;